const getCurrentRoute = () => {
  return window.location.href;
};

export default getCurrentRoute;
